/**
 * menu dla opcji użytkownika
 */

export default []
